import _ from 'lodash'

import {
  getUuid,
  findUpProperty,
} from '../../utils'

import {
  validate,
  parseValidators2Rules,
  getRules,
} from '../validator'

import zpaFormItem from '../form-item'

export const layoutProps = {
  span: Number,

  push: Number,

  pull: Number,
}

export const validateProps = {
  required: Boolean,

  readonly: {
    type: [Object, Boolean],
    default: undefined,
  },

  useCustomReadonly: Boolean,

  readonlyExpression: String,

  disabled: Boolean,

  hideCode: Boolean,

  clearable: {
    type: Boolean,
    default: true,
  },

  useCustomValidate: Boolean,

  validateJS: String,

  len: Number,

  max: Number,

  min: Number,

  pattern: [RegExp, String, Object],

  message: String,

  validators: [RegExp, String, Object, Array, Function],

  validatorsMessage: String,
}

export const labelProps = {
  label: String,

  labelWidth: [Number, String],

  labelAlign: String,

  labelPosition: String,

  itemHeight: Number,

  size: String,
}

export default {
  data() {
    return {
      error: '',

      success: false,

      validating: false,

      initialValue: undefined,

      vType: undefined,
    }
  },

  components: {
    zpaFormItem,
  },

  inject: ['form', 'group'],

  props: {
    ...layoutProps,

    ...validateProps,

    ...labelProps,

    id: String,

    value: String,

    labelInValue: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    uuid() {
      return this.id || `input_${getUuid()}`
    },

    rules() {
      const label = this.label
      const rules = parseValidators2Rules(this.validators, this.validatorsMessage)
      const type = this.type || this.vType

      return getRules.call(this, { label, type, rules })
    },

    $size() {
      return findUpProperty(this, 'size', 'default')
    },

    $readonly() {
      return findUpProperty(this, 'readonly', false)
    },

    valueFmt() {
      // return this.hideCode(this.value, 1, 1)
      return this.disabled && this.hideCode ? this.hideCodeMethod(this.value, 1, 1) : this.value
    },
  },

  methods: {
    validate,

    debounceValidate: _.debounce(validate, 120),

    reset() {
      this.error = ''
      this.success = false
      this.validating = false
      this.$emit('input', this.initialValue)
    },

    hideCodeMethod(str, frontLen, endLen) { // 脱敏
      if (!str || str.length <= frontLen + endLen) return str
      var len = str.length - frontLen - endLen
      var xing = ''
      for (var i = 0; i < len; i++) {
        xing += '*'
      }
      return str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
    },

    onInputChange(value) {
      if (value && this.isTrim) {
        value = value.trim()
      }
      this._initialValue = true
      const d = value === undefined || value === null ? value : value.target ? value.target.value : value
      this.$emit('input', d)
      this.$emit('on-change', d)
      this.debounceValidate()
    },

    onSend(e, value) {
      e.stopPropagation()
      this.$emit('send', !value ? undefined : value.target ? value.target.value : value)
    },
  },

  watch: {
    value: {
      handler(val) {
        if (!this._initialValue && val) { // 记录初始值（只记录一次）
          this.initialValue = val
          this._initialValue = true
        }
      },
      immediate: true,
    },
  },

  mounted() {
    if (!this.form) return

    this.form.addField(this, this.group)
  },

  beforeDestroy() {
    if (!this.form) return

    this.form.removeField(this, this.group)
  },
}
